import React, {FC} from "react"

import FormattedMessage, {InjectIntl, injectIntl} from "@irati/utils/lang"

import Flex from "@irati/ui/src/Flex"
import {H4} from "@irati/ui/src/Typography"
import {useTheme} from "@irati/ui/src/global/useTheme"
import {Hr} from "@irati/ui/src/Layout"
import Icon, {IconTypes} from "@irati/ui/src/Icon"

import {CustomCard, StyledH5, StyledLabel} from "./styled"

export interface ProductOption {
  name: string
  value: string
  body?: string
  bold?: string[]
  checked: boolean
}

interface Props extends InjectIntl {
  product: ProductOption
  onSelect: (product: string) => void
}

const ProductCard: FC<Props> = ({product, onSelect}) => {
  const theme = useTheme()
  const body = product.body

  const handleOnClick = () => {
    if (!product.checked) {
      onSelect(product)
    }
  }

  return (
    <CustomCard
      noBorder
      isSelected={product.checked}
      onClick={handleOnClick}
      bgColor={theme.colors.greys.lightest}
      padding={[theme.spacing.oneAndHalf, theme.spacing.oneAndHalf]}>
      <Flex alignItems="center">
        <Icon icon={product.checked ? IconTypes.circleCheckFill : IconTypes.circle} size={22} marginRight />
        <H4 color={theme.colors.greys.black}>{product.name}</H4>
      </Flex>
      {body && (
        <>
          <Hr marginTop={theme.spacing.oneAndHalf} marginBottom />
          <StyledH5 color={theme.colors.greys.mediumDark}>
            <FormattedMessage
              id={body}
              values={{
                bold1: (
                  <StyledLabel weight="bold" color={theme.colors.greys.mediumDark}>
                    <FormattedMessage id={product.bold[0]} />
                  </StyledLabel>
                ),
                bold2: (
                  <StyledLabel weight="bold" color={theme.colors.greys.mediumDark}>
                    <FormattedMessage id={product.bold[1]} />
                  </StyledLabel>
                ),
                bold3: (
                  <StyledLabel weight="bold" color={theme.colors.greys.mediumDark}>
                    <FormattedMessage id={product.bold[2]} />
                  </StyledLabel>
                )
              }}
            />
          </StyledH5>
        </>
      )}
    </CustomCard>
  )
}

export default injectIntl(ProductCard)
